import { Box, Typography, Stack, Button } from "@mui/material"
import { Sheet } from "react-modal-sheet"
import { useCallback } from "react"
import { Segment } from "../model/Route"
import { Place } from "../model/Station"

export const StationBottomSheet = (props: { place: Place, segment?: Segment, onClose: () => void }) => {

    const handleCopyLink = useCallback(() => {
        navigator.clipboard.writeText(`https://evpoint.kz/stations?id=${props.place.id}`)
    }, [props.place.id]);

    return (
        <Sheet detent='content-height' isOpen onClose={props.onClose}>
            <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <Box marginX={2} marginBottom={2}>
                        {props.segment && (
                            <div>
                                <Typography variant='h6'>Сегмент #{props.segment?.id}</Typography>
                                <Typography sx={{ userSelect: 'text' }}>Place ID: {props.place.id}</Typography>
                            </div>
                        )}
                        <Typography variant='h6'>{props.place.title}</Typography>
                        <Stack direction="row">
                            <Typography variant='caption'>{props.place.address}</Typography>
                            {props.place.city && <Typography variant='caption'>, {props.place.city}</Typography>}
                        </Stack>
                        {/* <Stack direction="row">
                            <Typography variant='caption'>Порты:</Typography>
                            {
                                <Typography variant='caption'>{props.station?.outlets.map((o) => o.connector).join(', ')}</Typography>
                            }
                        </Stack>
                        {props.station.wattage && <Typography variant='subtitle1'>Мощность: {props.station.wattage} кВт</Typography>}
                        <Typography>{props.station.provider}</Typography> */}

                        <Button variant="contained" sx={{ mt: 2 }} disableElevation onClick={handleCopyLink}>Скопировать ссылку</Button>
                        {/* <Stack overflow={'auto'} direction="row" spacing={2} marginTop={1}>
                        <Button variant="contained" disableElevation onClick={handlePaymentClick}>Оплатить</Button>
                        <IconButton size="medium" onClick={handleOpenNavigationClick}><DirectionsIcon /></IconButton>
                        <IconButton size="medium" onClick={handleShareClick}><ShareIcon /></IconButton>
                        {props.station?.provider?.supportLink && <IconButton size="medium" onClick={handleOpenSupportClick}><HeadsetMicIcon /></IconButton>}
                      </Stack> */}

                    </Box>
                </Sheet.Content>
            </Sheet.Container>
        </Sheet>
    )
}